import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const arrowUpSvg = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none">
        <path stroke="currentColor" d="M14.5 6.5V22m0-15.5L11 10m3.5-3.5L18 10"></path>
    </svg>
)

const ArrowUpKeyboard: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {arrowUpSvg}
    </SvgIcon>
)

export default ArrowUpKeyboard